<template>
  <d-container fluid class="main-content-container px-4">
    <div class="page-header row no-gutters py-4">
      <div class="d-flex justify-content-between no-gutters col-12">
        <div class="col-3 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Service Location</span>
          <h3 class="page-title">Overview</h3>
        </div>
        <div class="d-flex justify-content-end align-items-end col-9">
          <d-select class="col-2" v-model="country">
            <option selected value="">Select country</option>
            <template v-for="item in countries">
              <option :value="item" >
                {{ item }}
              </option>
            </template>
          </d-select>
          <d-input class="col-6" name='searchField' type="text" v-model="search" placeholder="filter provider page by name"></d-input>
          <d-button class="btn btn-primary ml-3 col-2" type="submit" @click="onAddNewProviderPage" onclick="">Add Provider page</d-button>
        </div>
      </div>
    </div>

    <d-card>
      a
      <d-card-body class="p-0">
        <div class="table-responsive">
          <table class="table mb-0">
            <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0"></th>
                <th scope="col" class="border-0" >Provider page</th>
                <th scope="col" class="border-0">Type</th>
                <th scope="col" class="border-0">Service</th>
                <th scope="col" class="border-0">Airport</th>
                <th scope="col" class="border-0" style="width: 100px;">Available</th>
              </tr>
            </thead>

            <tbody>
              <template v-for="providerPage in getPage">
                <tr style="cursor: pointer;" :key="providerPage.id" @click="onProviderPageClick(providerPage.id)">
                  <td style="width: 1px; white-space: nowrap; vertical-align: middle;">
                    <img v-if="providerPage.provider.logo != null" :src="providerPage.provider.logo.url" style="max-width: 100px; max-height: 50px;">
                    <img v-else src="../../assets/img/provider.png" style="max-width: 100px; max-height: 50px;">
                  </td>
                  <td style="vertical-align: middle;">
                    <strong style="font-size: .9rem;">{{providerPage.provider.name}}</strong><br>
                    <span style="color: #666;">{{providerPage.provider.location.address.street}}, {{providerPage.provider.location.address.city}}</span>
                  </td>
                  <td style="vertical-align: middle;">
                    {{providerPage.type.localizedName}}
                  </td>
                  <td style="vertical-align: middle;">
                    <d-badge :theme="checkForService(providerPage.coveredService)" class="mr-1">covered</d-badge>
                    <d-badge :theme="checkForService(providerPage.regularService)" >not covered</d-badge>
                  </td>
                  <td style="vertical-align: middle;">{{providerPage.provider.airport.localizedName}}, {{providerPage.provider.location.address.country}}</td>
                  <td style="vertical-align: middle; font-weight: 500;" class="text-success" v-if="providerPage.available">Yes</td>
                  <td style="vertical-align: middle; font-weight: 500;" class="text-danger" v-if="!providerPage.available">No</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </d-card-body>

      <v-pagination
        v-on:goToPage="goToPage($event)"
        ref="pagination"
        :filteredData="filteredProviderList"
        :activePage="currentPage"
        :totalPage="totalPage" >
      </v-pagination>

    </d-card>
  </d-container>
</template>

<script>
export default {
  methods: {
    getLogoUrl: function (url) {
      return url;
    },

    onAddNewProviderPage: function ($event) {
	    this.$router.push({
		    name: 'serviceLocations.create'
	    });
    },

    onProviderPageClick: function ($event) {
      this.$router.push({
        params: {
          id: $event,
        },
        name: 'serviceLocations.single',
      });
    },

    checkForService(service) {
      return (service !== null) ? 'success' : 'danger';
    },

    goToPage: function (id) {
      this.currentPage = id
      this.getPage;
    }

  },
  computed: {
    filteredProviderList() {
      return this.serviceLocations.filter(item => {
        if(this.country !== '' && item.provider.location.address.country === this.country) {
          this.currentPage = 1
          this.$refs.pagination.resetPage()
          return item.provider.name.toLowerCase().includes(this.search.toLowerCase());
        } else if(this.country === '') {
          return item.provider.name.toLowerCase().includes(this.search.toLowerCase());
        }
      })
    },
    getPage() {
      return this.filteredProviderList.slice((this.currentPage - 1) * this.totalPage, this.currentPage * this.totalPage);
    },

  },

  apollo: {
    load: function () {
      return {
        update: function (data) {
          this.serviceLocations = data.serviceLocations;
          this.countries = [...new Set(this.serviceLocations.map(item => item.provider.location.address.country))];
        },
        query: require('../../graphql/GetProvidersOverview.gql'),
      };
    },
  },

  data: function () {
    return {
      currentPage: 1,
      totalPage: 25,
      search: '',
      serviceLocations: [],
      countries: [],
      country: ''
    };
  },
};
</script>
